/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { CompleteCourseOptions, CompleteCourseResponses } from '../../models/CompleteCourse'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Mark a course as completed by the authenticated user.
 * @summary Complete Course
 * {@link /course/:course_id/complete}
 */
export function completeCourse<ThrowOnError extends boolean = true>(options: Options<CompleteCourseOptions, ThrowOnError>): Promise<UnwrappedResult<CompleteCourseResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/course/{course_id}/complete', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<CompleteCourseResponses, ThrowOnError>>
}
